module.exports = __webpack_public_path__ + "img/lit-chateau.3ce2208b.png";